export enum CheckbotStatusEnum {
  ok = 'OK',
  critical = 'Critical',
  error = 'Error',
  warning = 'Warning',
  info = 'Info',

  // internally used checkbot statutes
  timedOut = 'timed out',
  waiting = 'waiting',
  failed = 'failed',
}
